export const paths = {
  root: `/`,
  login: "/",
  dashboard: `/dashboard`,
  patient: {
    details: `/patient`,
  },
  guidelines: `/guidelines`,
  analytics: "/analytics",
};
